import _ from '@lodash';
import clsx from 'clsx';
import { useFormContext } from 'react-hook-form';
import { Button } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { showMessage } from 'app/store/fuse/messageSlice';
import { useState } from 'react';

import UserService from 'app/admin/user/service/UserService';

export default function PasswordResetRequestField(props) {
    const methods = useFormContext();
    const { compact = false } = props;

    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);

    const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    const send = () => {
        console.log('go');
        const values = methods.getValues();
        const email = values?.passwordEmail;

        if (!email) {
            dispatch(showMessage({ message: 'Email is required.' }));
            return;
        }
        if (!EMAIL_RE.test(email)) {
            dispatch(showMessage({ message: 'Invalid email format.' }));
            return;
        }

        setLoading(true);

        UserService.requestPasswordReset(email).then((response) => {
            if (response == null) {
                dispatch(showMessage({ message: 'Password reset email sent.' }));
            } else {
                const err =
                    (typeof response === 'string' && response) ||
                    response?.message ||
                    response?.error ||
                    'Password reset request failed.';
                dispatch(showMessage({ message: err }));
            }
        }).catch((e) => {
            const err = e?.message || 'Unexpected error while requesting password reset.';
            dispatch(showMessage({ message: err }));
        }).finally(() => {
            setLoading(false);
        });
    };

    return (
        <div className={clsx(compact ? 'flex items-center px-8' : 'flex items-center px-8 mt-8 mb-16', props.fieldConfig?.className)}        >
            <Button variant="contained" color="primary" className="w-full" onClick={send} disabled={loading}>
                {loading ? 'Sending…' : 'Request Password Reset'}
            </Button>
        </div>
    );
}
